import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid, Paper } from '@mui/material';

import isFoodora from 'src/utils/is-foodora/is-foodora';

import { PlanTile } from '../PlanTile';
import { LandingPageProps } from './types';

export const LandingPage = ({
  tiers,
  onSelectTier,
  config
}: LandingPageProps) => {
  const isFoodoraPro = isFoodora();
  return (
    <Paper
      sx={{
        padding: '32px 24px',
        height: '100%',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px'
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        direction="column"
        gap={2}
      >
        <Typography type="title-xl">
          Choose a {isFoodoraPro ? 'foodora PRO' : 'pandapro'} plan
        </Typography>
        <Typography type="paragraph-md">
          Spend less, get more! {isFoodoraPro ? 'foodora PRO' : 'pandapro'}{' '}
          users save an average of 25% on every order.
        </Typography>
        <Grid item container spacing={2} gap={2} justifyContent="center">
          {tiers.map((tier, idx) => {
            return (
              <PlanTile
                key={idx}
                currencyCode={config.currencyCode}
                tier={tier}
                onClick={() => onSelectTier(idx)}
              />
            );
          })}
        </Grid>
      </Grid>
    </Paper>
  );
};
